import styled from 'styled-components/native'
import colors from '@instaseat/lib/themes/colors'

export const ElapsedTimeText = styled.Text<{overtime: boolean}>`
  font-size: 12px;
  color: ${(props) => props.overtime ? colors.errorColor : '#707070'};
`
